<template>
  <div>
    <ChartsFilter :area-options="areaList" :category-options="cateList" :name-options="nameList" @search="handleSearch" />
  </div>
</template>

<script>
import ChartsFilter from '@/components/ChartsFilter.vue'
export default {
  components: { ChartsFilter },
  data() {
    return {
      areaList: [
        { label: '华东', value: 'east' },
        { label: '华南', value: 'south' }
      ],
      cateList: [
        { label: '蔬菜', value: 'veg' },
        { label: '水果', value: 'fruit' }
      ],
      nameList: [
        { label: '水稻', value: 'rice' },
        { label: '小麦', value: 'wheat' }
      ]
    }
  },
  methods: {
    handleSearch(params) {
      console.log('请求参数:', params)
      // 此处调用真实接口
    }
  }
}
</script>
